import { ApiResponse } from "../../shared/types"

export class OfflineError extends Error {
  constructor() {
    super('No network connection');
    this.name = 'OfflineError';
  }
}

export async function api<T>(path: string, init?: RequestInit): Promise<T> {
  let res: Response;
  try {
    res = await fetch(path, {
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
      ...init,
    });
  } catch (e) {
    // Network failure (offline, DNS, connection refused)
    throw new OfflineError();
  }
  if (res.status === 401) {
    window.location.href = '/login';
    throw new Error('Session expired');
  }
  const json = (await res.json()) as ApiResponse<T>
  if (!res.ok || !json.success || json.data === undefined) throw new Error(json.error || 'Request failed')
  return json.data
}
